import { createAction, createSlice } from '@reduxjs/toolkit';

const resetState = createAction('logoutSlice/logoutSuccess');

export const createAppSlice = ({ name, initialState, reducers }) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      ...reducers,
    },

    extraReducers: (builder) => {
      builder.addCase(resetState, () => ({ ...initialState }));
    },
  });
};
